


































import { Component, Vue, Prop } from "vue-property-decorator";
import ProjectWorkerTable from "./ProjectWorkerTable.vue";
import { client } from "../../api/request";
import ProjectTaskTypeApi from "@/api/project/project-task-type-api";
import ProjectCompanyApi from "@/api/project/project-company-api";
import ProjectWorkerApi from "@/api/project/project-worker-api";
import ProjectWorkerTableItem from "@/viewmodels/project-worker-table-item";
import ProjectWorkerTableItemDecorator from "@/decorators/project-worker-table-item-decorator";
import SelectTaskType from "./SelectTaskType.vue";
import TaskType from "../../entities/task-type";
import SelectProjectCompany from "./SelectProjectCompany.vue";
import ProjectCompany from "@/models/project-company";
import SelectFavorite from "./SelectFavorite.vue";

const taskTypeApi = new ProjectTaskTypeApi(client);
const companyApi = new ProjectCompanyApi(client);
const workerApi = new ProjectWorkerApi(client);

@Component({
  components: {
    ProjectWorkerTable,
    SelectTaskType,
    SelectProjectCompany,
    SelectFavorite
  }
})
export default class SelectProjectWorkers extends Vue {
  @Prop({ required: true }) projectId!: number;
  @Prop({ required: true }) selectedIds!: number[];

  favorite = "";
  selectedTaskTypes: TaskType[] = [];
  companyId = "";

  taskTypes: TaskType[] = [];
  companies: ProjectCompany[] = [];
  items: ProjectWorkerTableItem[] = [];

  checkAllStatus: boolean = false;

  created() {
    this.loadTaskTypes();
    this.loadCompanies();
    this.loadUnassignedWorkers();
  }

  updateTaskType(selectedTaskTypes: TaskType[]) {
    this.selectedTaskTypes = selectedTaskTypes;
    this.companyId = "";
    this.loadCompanies();
    this.select([]);
    this.loadUnassignedWorkers();
  }

  updateCompany(companyId: string) {
    this.companyId = companyId;
    this.select([]);
    this.loadUnassignedWorkers();
  }

  updateFavorite(favorite: string) {
    this.favorite = favorite;
    this.companyId = "";
    this.loadCompanies();
    this.select([]);
    this.loadUnassignedWorkers();
  }

  select(selectedIds: number[]) {
    this.$emit("select", selectedIds);
  }

  private get taskTypeIds(): string[] {
    return this.selectedTaskTypes.map(t => String(t.id));
  }

  private async loadTaskTypes() {
    this.taskTypes = await taskTypeApi.all(this.projectId);
  }

  private async loadCompanies() {
    const options = {
      taskTypeIds: this.taskTypeIds,
      favorite: this.favorite
    };
    this.companies = await companyApi.all(this.projectId, options);
  }

  private async loadUnassignedWorkers() {
    const options = {
      taskTypeIds: this.taskTypeIds,
      companyId: this.companyId,
      favorite: this.favorite
    };
    this.items = (await workerApi.unassigned(this.projectId, options)).map(
      ProjectWorkerTableItemDecorator
    );

    // Fillter Staff is_hidden_info
    this.items = this.items.filter(item => item.isHiddenInfo === 0);
  }
  // 全チェックのON/OFFで、全てのチェックボックスをON/OFF
  checkAll(checkBoxStatus: boolean) {
    if (checkBoxStatus == true) {
      // console.log("UnCheckAll: 全チェック True なら、全部のチェックを外す");
      this.select([]);
    } else {
      // console.log("CheckAll: 全チェック False なら、全部のチェックをつける");
      this.select(this.items.map(item => item.id));
    }
  }
}
